import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class PettyCashSlideOver extends Service {
  @tracked transaction = null;
}
